
export const PROJECT_DESCRIPTION = 1500;